import { finish, error } from '../../../modules/languages/actions/find';

import api from '../../../api';
           
export function request(dispatch){
    api.get('/translations/site/all').then(
        (languages) => dispatch(finish(languages)),
        ({ errors }) => dispatch(error(errors))
    );
};